var $ = require('jquery')
var tether = require('tether')
window.jQuery = $
window.$ = $
window.Tether = tether

require('bootstrap')

require("../css/rype-bootstrap.css")

module.exports.$ = window.$



//////////////////
// WEBPACK FOOTER
// ./rype-bootstrap/dist/js/rype-bootstrap.js
// module id = 14
// module chunks = 0